'use client'

import { memo, Ref, useState } from 'react'
import { IconChevronDown } from '@tabler/icons-react'
import clsx from 'clsx'

import Button from 'shared/ui/Button'
import { ButtonVariants } from 'shared/ui/Button/Button.enums'
import { addTestId } from 'shared/utils/tests'

import { CartPorts } from '../../../ports'

import CartPricingSummary from './CartPricingSummary'

import styles from './CartSummaryMobile.module.scss'

const CartSummaryMobile = ({
  destination = 'cart',
  isCartDrawer = false,
  handleModalClose,
  ports,
  ref
}: {
  destination?: string
  previousPage?: string
  isCartDrawer?: boolean
  handleModalClose?: () => void
  ports: CartPorts
  ref?: Ref<HTMLDivElement>
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(prev => !prev)
  }

  return (
    <div className={styles.wrapper} ref={ref}>
      <CartPricingSummary
        destination={destination}
        isExpanded={isExpanded}
        isMobile
        isCartDrawer={isCartDrawer}
        handleModalClose={handleModalClose}
        ports={ports}
      />
      <Button
        className={clsx(styles.expandButton, {
          [styles.expandButtonCollapsed]: !isExpanded
        })}
        variant={ButtonVariants.textInherit}
        onClick={toggleExpand}
        aria-expanded={isExpanded}
        aria-controls='cart-summary'
        {...addTestId('cart-expand-button')}
      >
        {isExpanded ? (
          <>
            Ukryj szczegóły
            <IconChevronDown />
          </>
        ) : (
          <>
            Pokaż szczegóły
            <IconChevronDown />
          </>
        )}
      </Button>
    </div>
  )
}

export default memo(CartSummaryMobile)
